<template>
  <div class="store-info-bar">
    <div class="store-info">
      <LocationIcon />
      <span>{{ $i18n.choice(store.address) }}</span>
      <TelIcon />
      <span>{{ store.tel }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LocationIcon from '@/components/icons/location'
import TelIcon from '@/components/icons/tel-outline'

/**
 * 店舗情報バー
 */
export default {
  name: 'StoreInfoBar',
  components: {
    LocationIcon,
    TelIcon,
  },
  computed: {
    ...mapState({
      store: state => state.reception.setting.store,
    }),
  },
}
</script>

<style lang="postcss" scoped>
.store-info-bar {
  background: var(--white);
  padding: 16px;
}

.store-info {
  align-items: center;
  display: grid;
  grid-gap: 8px 12px;
  grid-template-columns: max-content auto;
  line-height: 1.2;
  margin: 0 auto;
  max-width: 940px;
  width: 100%;

  & svg {
    height: 16px;
    width: 16px;
  }

  @media screen and (min-width: 768px) {
    font-size: 16px;
    grid-template-columns: max-content auto max-content auto;
    justify-content: flex-start;

    & svg {
      height: 24px;
      width: 24px;
    }
  }
}
</style>
